// 直播类型
export const LIVE_MODE_MAP = {
  AUDIO: 1, // 音频
  VIDEO: 2, // 视频
  INTERACT: 3, // 互动
  GROUP: 6 //分组
};
